export const color = '#5F9FFF'
export const text = `black`